import React from 'react';
import L from 'leaflet';
import './Map.css';

class Map extends React.Component {

  componentDidMount() {

    var mapMarker = L.icon({
      iconUrl: 'https://cdn1.iconfinder.com/data/icons/vibrancie-action/30/action_077-location-map-marker-pin-place-512.png',
      iconSize: [35, 35],
      iconAnchor: [18, 30],
      popupAnchor: [-1, -30]
    });

    if (this.props.popupProperties != null) {
      this.map = L.map('map', {
        center: [this.props.coordinatesList[0].latitude, this.props.coordinatesList[0].longitude],
        zoom: this.props.zoom,
        zoomControl: true,
        //fadeAnimation: false,
        layers: [
          L.tileLayer('https://api.mapbox.com/styles/v1/fmoberg/ck3sg9fvc01l21cobd067uees/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZm1vYmVyZyIsImEiOiJjazNzZzdwYmowNjY0M2xvOWJucXpkcmU2In0.CVCFzunXIT_k8BswTMj2tA', {
            attribution:
              '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          })
        ]
      });

      this.map.zoomControl.setPosition('bottomright');
      const bounds = L.latLngBounds();
      this.props.coordinatesList.forEach((x, i) => {
        if (x.latitude && x.longitude) {
          this.marker = L.marker([x.latitude, x.longitude], { icon: mapMarker })
            .addTo(this.map)
            .bindPopup(
              "<a href=\"" + this.props.popupProperties[i].officePageUrl + "\" style=\"font-size: 14px; color: #FC8600\"><strong>" +
              this.props.popupProperties[i].header.toUpperCase() + "</strong></a><br />" +
              (this.props.popupProperties[i].postAddress !== '' ? "Postadress: " + this.props.popupProperties[i].postAddress + "<br />" : '') +
              ((this.props.popupProperties[i].visitingAddress !== '') ?
                ("Besöksadress: <a href=\"http://maps.google.com/?q=" +
                  encodeURIComponent(this.props.popupProperties[i].visitingAddress) + "\" target=\"_blank\" rel=\"noreferrer\" style=\"color: #FC8600\"> " +
                  this.props.popupProperties[i].visitingAddress + " </a><br />") : '') +
              (this.props.popupProperties[i].phone !== '' ? "Telefon: " + this.props.popupProperties[i].phone + "<br />" : '') +
              (this.props.popupProperties[i].secondaryPhone !== '' && this.props.popupProperties[i].secondaryPhoneName !== '' ? this.props.popupProperties[i].secondaryPhoneName + ": " + this.props.popupProperties[i].secondaryPhone + "<br />" : '') +
              (this.props.popupProperties[i].thirdPhone !== '' && this.props.popupProperties[i].thirdPhoneName !== '' ? this.props.popupProperties[i].thirdPhoneName + ": " + this.props.popupProperties[i].thirdPhone + "<br />" : '') +
              (this.props.popupProperties[i].email !== '' ? "E-post: " + this.props.popupProperties[i].email + "<br />" : '')
            );

          bounds.extend({ lat: x.latitude, lng: x.longitude });
        }
      });
      this.map.fitBounds(bounds);

    }
    else {
      this.map = L.map('map', {
        center: [this.props.coordinatesList[0].latitude, this.props.coordinatesList[0].longitude],
        zoom: this.props.zoom,
        zoomControl: true,
        layers: [
          L.tileLayer('https://api.mapbox.com/styles/v1/fmoberg/ck3sg9fvc01l21cobd067uees/tiles/256/{z}/{x}/{y}@2x?access_token=pk.eyJ1IjoiZm1vYmVyZyIsImEiOiJjazNzZzdwYmowNjY0M2xvOWJucXpkcmU2In0.CVCFzunXIT_k8BswTMj2tA', {
            attribution:
              '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          })
        ]
      });
      this.map.zoomControl.setPosition('bottomright');
      this.marker = L.marker([this.props.coordinatesList[0].latitude, this.props.coordinatesList[0].longitude], { icon: mapMarker })
        .addTo(this.map);

    }
  }

  render() {
    return (
      <div id="map" style={{ height: this.props.height, width: this.props.width }}></div>
    );
  }

}
export default Map;